import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren} from '@angular/core';
import {Store} from "@ngrx/store";
import {first, Subscription} from "rxjs";
import {
  Config,
  getConfig,
  getLookups, getSelectedEntityKyc,
  initialConfigState,
  initialLookupsState,
  Lookups, toggleLoading, updateSelectedEntityKyc,
} from "../../../redux";
import {AbstractControl, FormArray, FormControl, FormGroup} from "@angular/forms";
import {ConfirmationModalComponent, DeleteConfirmationModalComponent, UserCardSize} from "../../../shared/components";
import {UtilService} from "../../../shared/services";
import {ModalSize} from "../../../shared/services/util/util.service";
import {KycPersonModalComponent} from "../kyc-person-modal/kyc-person-modal.component";
import {MatDialog} from "@angular/material/dialog";
import {KycPersonSelectModalComponent} from "../kyc-person-select-modal/kyc-person-select-modal.component";
import {KycBusinessModalComponent} from "../kyc-business-modal/kyc-business-modal.component";
import {KycBusinessSelectModalComponent} from "../kyc-business-select-modal/kyc-business-select-modal.component";
import {
  IEntityKyc,
  IKycAnswer,
  IEntityKycError,
  IKycQuestion,
  IKycSection
} from "../../models/entity";
import {EntityKycPersonService} from "../../services/entity-kyc-person.service";
import {ToastrService} from "ngx-toastr";
import {IKycEntityImportPerson, IKycPerson} from "../../models/i-kyc-person";
import {EntityKycService} from "../../services/entity-kyc.service";
import {EntityKycBusinessService} from "../../services/entity-kyc-business.service";
import {IKycEntityImportLegalEntity, IKycLegalEntity} from "../../models/i-kyc-legal-entity";
import {ActivatedRoute, Router} from "@angular/router";
import {Level, ModalFunction, IQuestionAnswer, SectionType as KycSectionType, SectionType} from "../../models/kyc";
import {LookupService, UuidService} from "../../../../services";
import {KycImportModalComponent} from "../kyc-import-modal/kyc-import-modal.component";
import { AddVotingRightsOwnerComponent } from 'src/app/dialogs/thirdparty/add-voting-rights-owner/add-voting-rights-owner.component';
import { AddAuthorizedSignatoryComponent } from 'src/app/dialogs/thirdparty/add-authorized-signatory/add-authorized-signatory.component';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { KycPrimaryContactPersonModalComponent } from '../kyc-primary-contact-person-modal/kyc-primary-contact-person-modal.component';
import { DataService } from 'src/app/services/data/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatCheckboxChange } from '@angular/material/checkbox';

enum EnumKycLegalEntityRondeivuStatus
{
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
  NEEDS_MORE_INFO = 'NEEDS_MORE_INFO',
  READY_FOR_APPROVAL = 'READY_FOR_APPROVAL',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED'
}

@Component({
  selector: 'app-kyc-input',
  templateUrl: './kyc-input.component.html',
  styleUrls: ['./kyc-input.component.scss']
})
export class KycInputComponent implements OnInit {

  @ViewChild('mainAccordion', { read: ElementRef }) mainAccordion!: ElementRef;
  @ViewChild('cacheAccordion', { read: ElementRef }) cacheAccordion!: ElementRef;
  @ViewChildren(MatExpansionPanel) expansionPanels!: QueryList<MatExpansionPanel>;


  protected readonly SectionType = KycSectionType;
  protected readonly Level = Level;
  protected readonly userCardSize = UserCardSize;
  protected readonly IN_USE_COLOR = '#0e41af';
  protected readonly NOT_IN_USE_COLOR = '#ffa516';
  protected readonly IN_USE_TEXT = 'Currently used in this KYC';
  protected readonly NOT_IN_USE_TEXT = 'Not used in this KYC';
  // formDisabled = false; // this is used to test the form lock state
  step: string = KycSectionType.ONBOARDING;

  selectedEntityKycId: string = '';
  selectedEntityKyc!: IEntityKyc;
  formDirty = false;
  showCertificationOnly = false;
  openedKycSection?: KycSectionType = KycSectionType.REGULATORY_QUESTIONS_1;

  /*
   This form is for:
    PUT /api/businesssunitentitykyc
   */
  adminSettingsForm: FormGroup = new FormGroup({
    id: new FormControl(),
    archived: new FormControl(),
    entityType: new FormControl(),
    kycRondeivuStatus: new FormControl(),
    kycName: new FormControl(''),
    publicComments: new FormControl(''),
    privateComments: new FormControl(''),
  })


  form!: FormGroup;

  protected readonly FORM_ONBOARDING_PEOPLE = 'onboardingPeople';
  protected readonly FORM_CLIENT_ENTITY = 'onboardingEntities';
  protected readonly FORM_CONTROL_PEOPLE = 'controlPeople';
  protected readonly FORM_REG_PEOPLE = 'regulatoryPeople';
  protected readonly FORM_REG_ENT = 'regulatoryEntities';
  protected readonly FORM_DBO_PEOPLE = 'dboPeople';
  protected readonly FORM_DBO_ENTITIES = 'dboEntities';
  protected readonly FORM_IDBO_PEOPLE = 'idboPeople';
  protected readonly FORM_IDBO_ENTITIES = 'idboEntities';
  protected readonly FORM_TRUST_PEOPLE = 'trusteePeople';
  protected readonly FORM_TRUST_ENTITIES = 'trusteeEntities';
  protected readonly FORM_TRUST_SET_PEOPLE = 'trustSettlorPeople';
  protected readonly FORM_TRUST_SET_ENTITIES = 'trustSettlorEntities';
  protected readonly FORM_TRUST_BEN_PEOPLE = 'trustBeneficiariesPeople';
  protected readonly FORM_TRUST_BEN_ENTITIES = 'trustBeneficiariesEntities';
  protected readonly FORM_GB_PEOPLE = 'governingBodyPeople';
  protected readonly FORM_GB_ENTITIES = 'governingBodyEntities';
  protected readonly FORM_AUTH_PEOPLE = 'authorizedSignatoryPeople';
  protected readonly FORM_PRIMARY_CONTACTS = 'primaryContacts';
  protected readonly FORM_DIRECTORS = 'directors';
  protected readonly FORM_HEADER_QUESTIONS = 'headerQuestionsAnswers';
  protected readonly FORM_QUESTIONS = 'questionsAnswers';

  protected readonly FORM_QUESTION_REG = 'RequlatoryQuestion_own_10_percent_or_more';
  protected readonly FORM_QUESTION_REG_2 = 'RequlatoryQuestion_authorized_signatories_a_director_of_OTC'
  protected readonly FORM_QUESTION_DBO = 'DBOQuestion_Control_Person_listed_above_is_also_a_Direct_Beneficial_Owner';
  protected readonly FORM_QUESTION_IDBO = 'IDBOQuestion_No_Owners';
  
  protected readonly ISSUER_NOT_LISTED_QUESTION = "IssuerLEQuestion_Not_Listed_below";
  personsCache: IKycPerson[] = [];
  legalEntitiesCache: IKycLegalEntity[] = [];


  constructor(
    public util: UtilService,
    private store: Store,
    private dialog: MatDialog,
    public lookupService: LookupService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private entityKycService: EntityKycService,
    private entityKycBusinessService: EntityKycBusinessService,
    private entityKycPersonService: EntityKycPersonService,
    private uuidService: UuidService,
    private dataService: DataService
  ) {

  }


  ngOnInit(): void {
    
    this.form = new FormGroup({
      id: new FormControl(),
      businessUnitEntityId: new FormControl(),
      onboardingPeople:  new FormArray([]), // {id:string}
      onboardingEntities: new FormArray([]), // {id:string,natureoftheBusiness:string,businessSourceofFund:string}
      controlPeople: new FormArray([]),// {id:string}
      
      // REGULATORY_QUESTIONS_1
      regulatoryPeople: new FormArray([]), // {id:string, ownerOfVotingRights:string, publiclyTradedCompany: string, percentageOwnership:number}
  
      // REGULATORY_QUESTIONS_2
      regulatoryEntities: new FormArray([]), // {id:string, authorizedSignatory: string, companyName: string, percentageOwnership:number}
  
      // 
      dboPeople: new FormArray([]), // {id:string,percentageOwnership:number}
      dboEntities: new FormArray([]), // {id:string,percentageOwnership:number}

      idboPeople: new FormArray([]), // {id:string,percentageOwnership:number}
      idboEntities: new FormArray([]), // {id:string,percentageOwnership:number}
      
      trusteePeople: new FormArray([]), // {id:string}
      trusteeEntities: new FormArray([]), // {id:string}
      trustSettlorPeople: new FormArray([]), // {id:string}
      trustSettlorEntities: new FormArray([]), // {id:string}
      trustBeneficiariesPeople: new FormArray([]), // {id:string}
      trustBeneficiariesEntities: new FormArray([]), // {id:string}
      governingBodyPeople: new FormArray([]), // {id:string}
      governingBodyEntities: new FormArray([]), // {id:string}
      authorizedSignatoryPeople: new FormArray([]), // {id:string,ownerShip:number}
      primaryContacts: new FormArray([]), // {id:string,firstName:string,lastName:string,email:string}
      directors: new FormArray([]), // {id:string}
      headerQuestionsAnswers: new FormArray<FormGroup>([]), // {questionAnswerAttribute:string,questionAnswer:string}
      questionsAnswers: new FormArray<FormGroup>([]) // {questionAnswerAttribute:string,questionAnswer:string}
    });

    
    this.selectedEntityKycId = this.activatedRoute.snapshot.paramMap.get("id") || '';
    if (!!this.selectedEntityKycId) {
      this.entityKycService.getEntityKycById(this.selectedEntityKycId).pipe(first()).subscribe({
        next: (kyc: IEntityKyc) => {
          // console.log("kyc", kyc);
          // kyc.kycSections.forEach(section => {
          //   section.opened = false;

          //   if (!!this.openedKycSection && section.kycSectionType == this.openedKycSection) {
          //     section.opened = true;
          //   }
          // })
          this.selectedEntityKyc = kyc;
          this.patchDataToKYC(kyc);

          // get persons and entities
          this.fetchLegalEntities();
          this.fetchPersons();
      
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error("There was an issue getting the KYC data");
        }
      });
    }
  }

  patchDataToKYC(kyc: IEntityKyc) {
    this.form.patchValue(kyc)
    this.adminSettingsForm.patchValue(kyc);

    // header questions for issuer KYC
    var formArray: FormArray = this.getFormArray(this.FORM_HEADER_QUESTIONS);
    this.selectedEntityKyc.kycHeader.kycQuestions.forEach(x => {
      x.questionAnswer = x.questionAnswer.toString() == "true";
      formArray.push(this.createFormGroupFromQuestionsArray(x));
    });

    // console.log("form array value", formArray.value)

    // disable header checkboxes if the first question is checked
    try {
      var headerCheckboxAllQuestions = (formArray.value as IKycQuestion[]).filter(x => x.questionAnswerAttribute == this.ISSUER_NOT_LISTED_QUESTION);

      if (headerCheckboxAllQuestions.length > 0) {
        var hideNonCertificationSections = headerCheckboxAllQuestions[0].questionAnswer.toString() == "true";
        if (hideNonCertificationSections == false) {
          // uncheck the other checkboxes
          this.selectedEntityKyc.kycSections.forEach(x => {
            x.hidden = x.kycSectionType != KycSectionType.CERTIFICATION
          })
        }
      }
    }
    catch (err) {
      console.error("KYC Set header questions error", err);
    }


    // patch section header questions
    var formArraySectionQuestions: FormArray = this.getFormArray(this.FORM_QUESTIONS);
    kyc.kycSections.flatMap(x => x.kycSectionHeader.kycQuestions).forEach(q => {
      formArraySectionQuestions.push(this.createFormGroupFromQuestionsArray(q));
    });


    // ONBOARDING
    this.addPersonsFromSectionToForm(KycSectionType.ONBOARDING, this.FORM_ONBOARDING_PEOPLE);

    // ENTITY_INFORMATION
    this.addLegalEntityFromSectionToForm(KycSectionType.ENTITY_INFORMATION, this.FORM_CLIENT_ENTITY);

    // ENTITY_INFORMATION
    this.addPersonsFromSectionToForm(KycSectionType.DIRECTORS, this.FORM_DIRECTORS);

    // REGULATORY_QUESTIONS_1
    this.addPersonsFromSectionToForm(KycSectionType.REGULATORY_QUESTIONS_1, this.FORM_REG_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.REGULATORY_QUESTIONS_2, this.FORM_REG_ENT);

    // CONTROL_PERSON
    this.addPersonsFromSectionToForm(KycSectionType.CONTROL_PERSON, this.FORM_CONTROL_PEOPLE);

    // DIRECT_BENEFICIAL_OWNERS
    this.addPersonsFromSectionToForm(KycSectionType.DIRECT_BENEFICIAL_OWNERS, this.FORM_DBO_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.DIRECT_BENEFICIAL_OWNERS, this.FORM_DBO_ENTITIES);

    // INDIRECT_BENEFICIAL_OWNERS
    this.addPersonsFromSectionToForm(KycSectionType.INDIRECT_BENEFICIAL_OWNERS, this.FORM_IDBO_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.INDIRECT_BENEFICIAL_OWNERS, this.FORM_IDBO_ENTITIES);

    // GOVERNING_BODY
    this.addPersonsFromSectionToForm(KycSectionType.GOVERNING_BODY, this.FORM_GB_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.GOVERNING_BODY, this.FORM_GB_ENTITIES);

    // TRUSTEES
    this.addPersonsFromSectionToForm(KycSectionType.TRUSTEES, this.FORM_TRUST_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.TRUSTEES, this.FORM_TRUST_ENTITIES);
    
    // TRUST_BENEFICIARIES
    this.addPersonsFromSectionToForm(KycSectionType.TRUST_BENEFICIARIES, this.FORM_TRUST_BEN_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.TRUST_BENEFICIARIES, this.FORM_TRUST_BEN_ENTITIES);
    
    // TRUST_SETTLORS
    this.addPersonsFromSectionToForm(KycSectionType.TRUST_SETTLORS, this.FORM_TRUST_SET_PEOPLE);
    this.addLegalEntityFromSectionToForm(KycSectionType.TRUST_SETTLORS, this.FORM_TRUST_SET_ENTITIES);

    // AUTHORIZED_SIGNATORIES
    this.addPersonsFromSectionToForm(KycSectionType.AUTHORIZED_SIGNATORIES, this.FORM_AUTH_PEOPLE);

    // PRIMARY_CONTACT
    this.addPersonsFromSectionToForm(KycSectionType.PRIMARY_CONTACT, this.FORM_PRIMARY_CONTACTS);

  }

  private addPersonsFromSectionToForm(sectionType: SectionType, formName: string) {
    var formArray = this.getFormArray(formName);
    this.getKycSection(sectionType)?.kycPeople?.forEach(x => {
      if (sectionType == SectionType.DIRECT_BENEFICIAL_OWNERS) {
        console.log(this.createFormGroupFromObject(x));
      }
      formArray.push(this.createFormGroupFromObject(x));
    });
  }

  private addLegalEntityFromSectionToForm(sectionType: SectionType, formName: string) {
    var formArray = this.getFormArray(formName);
    this.getKycSection(sectionType)?.legalEntity?.forEach(x => {
      formArray.push(this.createFormGroupFromObject(x));
    });
  }

  private createFormGroupFromQuestionsArray(question: IKycQuestion) : FormGroup {
    return new FormGroup({
      questionAnswerAttribute: new FormControl(question.questionAnswerAttribute),
      questionText: new FormControl(question.questionText),
      questionType: new FormControl(question.questionType),
      questionAnswer: new FormControl(question.questionAnswer),
    });
  }

  private createFormGroupFromObject(object: any) : FormGroup {
    var keys = Object.keys(object);
    var fg = new FormGroup({});

    if (object == null || keys.length == 0)
      return fg;

    if (!keys.includes('percentageOwnership'))
      keys.push('percentageOwnership');

    keys.forEach(key => {
      fg.addControl(key, new FormControl(object[key]));
    });

    return fg;
  }

  questionContainerInSection(question: IKycQuestion[], attributeName: string) : boolean {
    return question.filter(x => x.questionAnswerAttribute == attributeName).length > 0;
  }

  getQuestionByAttribute(questionAttribute: string) : IKycQuestion {
    var questions = this.getFormArray(this.FORM_QUESTIONS).value as IKycQuestion[];
    return questions.filter(x => x.questionAnswerAttribute == questionAttribute)[0];
  }

  removeItem(formKey: string, i: number) {
    console.log("DELETE ITEM", formKey, i);
    this.getFormArray(formKey).removeAt(i);
    this.personsCache = this.personsCache;
    this.legalEntitiesCache = this.legalEntitiesCache;
  }

  editItem_Person(id: string) {
    console.log("EDIT ITEM - person", id);
    var person = this.personsCache.filter(x => x.id == id)[0];
    
    this.dialog.open(KycPersonModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.LARGE),
      disableClose: true,
      data: {
        person: person,
        disabled: this.isFormDisabled(),
        isNewPerson: false
      }
    })
    .afterClosed().subscribe((result : IKycPerson) => {
      console.log("result", result);
      if (!!result) {
        this.entityKycPersonService.updateKycPerson(result).subscribe({
          next: () => {
            this.toastr.success("Changes saved");
            // get persons and update list
            this.entityKycPersonService.getKycPeopleByKycId(this.selectedEntityKycId).subscribe({
              next: (kycUpdatedPersons: IKycPerson[]) => {
                console.log("Get persons after update", kycUpdatedPersons)
                this.personsCache = kycUpdatedPersons;
              }
            })
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error("Could not perform operation");
          }
        })
      }
    });
  }

  editItem_LegalEntity(id: string) {
    console.log("EDIT ITEM - legal entity", id);
    var business = this.legalEntitiesCache.filter(x => x.id == id)[0];

    this.dialog.open(KycBusinessModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.MEDIUM),
      disableClose: true,
      data: {
        business: business,
        disabled: this.isFormDisabled(),
        isNewLegalEntity: false
      }
    })
    .afterClosed().subscribe((result : IKycLegalEntity) => {
      console.log("result", result);
      if (!!result) {
        this.entityKycBusinessService.updateKycLegalEntity(result).subscribe({
          next: () => {
            // this.personsCache = this.personsCache;
            // this.legalEntitiesCache = this.legalEntitiesCache;
            this.toastr.success("Changes saved");
            // get persons and update list
            this.entityKycBusinessService.getKycLegalEntityByKycId(this.selectedEntityKycId).subscribe({
              next: (kycUpdatedLegalEntities: IKycLegalEntity[]) => {
                console.log("Get LEs after update", kycUpdatedLegalEntities)
                this.legalEntitiesCache = kycUpdatedLegalEntities;
              }
            })
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error("Could not perform operation");
          }
        })
      }
    });
  }

  getInformationalErrors(section: IKycSection) : IEntityKycError[] {
    return section.errors.filter(x => x.errorType == "VALIDATION_ERROR");
  }

  getComplyAdvantageErrors(section: IKycSection) : IEntityKycError[] {
    return section.errors.filter(x => x.errorType == "COMPLY_ERROR");
  }

  getPersonFromCache(id: string) : IKycPerson {
    return this.personsCache.filter(x => x.id == id)[0];
  }

  getLegalEntityFromCache(id: string) : IKycLegalEntity {
    return this.legalEntitiesCache.filter(x => x.id == id)[0];
  }

  getKycSection(sectionType: SectionType | string) : IKycSection {
    return this.selectedEntityKyc.kycSections.filter(x => x.kycSectionType == sectionType)[0];
  }
  getFormArray(key: string) : FormArray {
    return this.form.get(key) as FormArray;
  }

  isFormCollectionEmpty(formName: string) : boolean {
    return this.getFormArray(formName).controls.length == 0;
  }

  kycHeaderQuestionCheckboxChanged (event: MatCheckboxChange) {
    var elem = event.source._elementRef as ElementRef;
    var elemId = elem.nativeElement.id;
    
    // console.log("checkbox changed", elem.nativeElement.id);

    try {
      if (elemId == this.ISSUER_NOT_LISTED_QUESTION) {
        // the first question was clicked

        var header = this.getFormArray(this.FORM_HEADER_QUESTIONS);
        var headerQuestions = header.value as IKycQuestion[];
        // console.log("first question clicked", event.checked)
        if (event.checked) {
          // it was checked, remove all other checkboxes

          // remove all other checkboxes
          var values = headerQuestions.map(x => {
            if (x.questionAnswerAttribute != this.ISSUER_NOT_LISTED_QUESTION) {
              x.questionAnswer = false;
            };

            return x;
          });

          header.patchValue(values);


          // show all sections
          this.selectedEntityKyc.kycSections.forEach(x => {
            x.hidden = false
          })

          // header.controls.forEach(x => {
          //   if (x.value.questionAnswerAttribute != this.ISSUER_NOT_LISTED_QUESTION) {
          //     x.disable();
          //   }
          // });
        }
        else {
          // hide sections other than certification
          this.selectedEntityKyc.kycSections.forEach(x => {
            x.hidden = x.kycSectionType != KycSectionType.CERTIFICATION;
          });


          // header.controls.forEach(x => x.enable());
        }
      } else {
        // uncheck the other boxes
        // todo Reza
      }
    }
    catch (err) {
      console.error(err);
    }
  }

  saveTheKyc() : Promise<any> {
    var formValue = this.form.value;
    return new Promise((resolve, reject) => {
      this.store.dispatch(toggleLoading({loading: true}));

      // change header questions from boolean to text
      var answers = formValue[this.FORM_HEADER_QUESTIONS] as IKycAnswer[];
      formValue[this.FORM_HEADER_QUESTIONS] = answers.map(x => {
        x.questionAnswer = x.questionAnswer.toString();
        return x;
      })

      console.log("SAVE KYC", formValue);
      this.entityKycService.updateEntityKyc(formValue).subscribe({
        next: () => {
          this.toastr.success("KYC saved");
          this.updateKyc()
            .then(() => {
              this.store.dispatch(toggleLoading({loading: false}));
              resolve(0);
            })
            .catch(() => {
              this.store.dispatch(toggleLoading({loading: false}));
              reject(0);
            });
        },
        error: (err: HttpErrorResponse) => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.toastr.error("KYC could not be saved!")
          console.log(err);
        }
      });
  
    });
  } 

  saveKyc()  {
    this.saveTheKyc().then(console.log).catch(console.error);
  }

  updateKyc() : Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.selectedEntityKycId) {
        reject(0);
        return;
      }

      this.entityKycService.getEntityKycById(this.selectedEntityKycId).pipe(first()).subscribe({
        next: (kyc: IEntityKyc) => {
          this.store.dispatch(toggleLoading({loading: false}));
          // console.log("kyc", kyc);
          
          // set the status and archived metrics
          this.selectedEntityKyc.archived = kyc.archived;
          this.selectedEntityKyc.kycRondeivuStatus = kyc.kycRondeivuStatus;

          kyc.kycSections.forEach(x => {
            var sections = this.selectedEntityKyc.kycSections.filter(f => f.kycSectionType == x.kycSectionType);

            if (sections.length > 0) {
              sections[0].errors = x.errors;
              console.log("section getting updated", sections[0], x.errors)
            }
          })
          
          this.fetchLegalEntities();
          this.fetchPersons();
          
          resolve(0);
        },
        error: (err: HttpErrorResponse) => {
          this.store.dispatch(toggleLoading({loading: false}));
          console.error(err)
          reject(err);
        }
      });
    });
  }

  submitKyc() {
    console.log("SUBMIT KYC");
    this.saveTheKyc().then(() => {
      console.log("CAN Submit", this.canSubmit());
      // var sectionErrors = this.selectedEntityKyc.kycSections?.flatMap(x => x.errors);
      // console.log("Section Errors", sectionErrors)
      if (this.canSubmit() == false) {
        this.toastr.error("Could not submit! KYC contains errors!");
        return;
      }
      
      this.store.dispatch(toggleLoading({loading: true}));
      this.entityKycService.submitEntityKyc(this.form.value).subscribe({
        next: () => {
          this.toastr.success("KYC Submitted");
          this.updateKyc().then(() => {
            this.store.dispatch(toggleLoading({loading: false}));
          })
          .catch(() => {
            this.store.dispatch(toggleLoading({loading: false}));
          })
        },
        error: (err: HttpErrorResponse) => {
          console.error(err);
          this.store.dispatch(toggleLoading({loading: false}));
        }
      });
    });
  }

  
  saveAdminSettings() {
    console.log("SUBMIT ADMIN", this.adminSettingsForm.value);
    // return;
    this.store.dispatch(toggleLoading({loading: true}));
    this.entityKycService.updateEntityKycAdminSettings(this.adminSettingsForm.value).subscribe({
      next: () => {
        this.ngOnInit();
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Entity KYC Admin Settings Updated!", $localize`:@@companyName:Rondeivu`);
      }, error: (error: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to update entity kyc admin settings!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  isFormDisabled() : boolean {
    // return false;
    if (!this.selectedEntityKyc)
      return false;

    // Reza removed this due to request from Steve (to still be able to edit KYC in draft status)
    // // if an admin is looking at draft, they shouldn't be able to change the data
    // if (this.util.isAdmin() && this.selectedEntityKyc.kycRondeivuStatus == EnumKycLegalEntityRondeivuStatus.DRAFT)
    //   return true;

    return this.selectedEntityKyc.kycRondeivuStatus == EnumKycLegalEntityRondeivuStatus.APPROVED ||
            this.selectedEntityKyc.kycRondeivuStatus == EnumKycLegalEntityRondeivuStatus.DECLINED ||
            this.selectedEntityKyc.kycRondeivuStatus == EnumKycLegalEntityRondeivuStatus.SUBMITTED ||
            this.selectedEntityKyc.archived
  }

  formHasAtLeastOneEntry(formName: string) : boolean {
    return this.getFormArray(formName).controls.length > 0;
  }

  canSubmit() : boolean {
    var kycSectionErrors = this.selectedEntityKyc.kycSections.flatMap(x => x.errors);
    // console.log("KYC errors", kycSectionErrors)
    if (kycSectionErrors.length > 0)
      return false;

    return this.selectedEntityKyc.kycRondeivuStatus == EnumKycLegalEntityRondeivuStatus.DRAFT ||
            this.selectedEntityKyc.kycRondeivuStatus == EnumKycLegalEntityRondeivuStatus.NEEDS_MORE_INFO; 
  }

  addOwnerOfVotingRights() {
    this.dialog.open(AddVotingRightsOwnerComponent, {
      width: this.util.getModalWidth(ModalSize.MEDIUM),
    })
    .afterClosed().subscribe(data => {
      console.log("data", data);
      if (!!data) {
        var votingOwnersFormArray = this.getFormArray(this.FORM_REG_PEOPLE);
        votingOwnersFormArray.push(this.createFormGroupFromObject(data));
      }
    })
  }

  addAuthorizeSignatory() {
    this.dialog.open(AddAuthorizedSignatoryComponent, {
      width: this.util.getModalWidth(ModalSize.MEDIUM),
    })
    .afterClosed().subscribe(data => {
      console.log("data", data);
      if (!!data) {
        var authorizedSignatoryFormArray = this.getFormArray(this.FORM_REG_ENT);
        authorizedSignatoryFormArray.push(this.createFormGroupFromObject(data));
      }
    })
  }

  addPrimaryContactPerson() {
    this.dialog.open(KycPrimaryContactPersonModalComponent, {
      width: this.util.getModalWidth(ModalSize.MEDIUM),
    })
    .afterClosed().subscribe(data => {
      console.log("data", data);
      if (!!data) {
        var formArray = this.getFormArray(this.FORM_PRIMARY_CONTACTS);
        formArray?.push(this.createFormGroupFromObject(data));
      }
    })
  }

  addPersonToForm(formName: string, level: Level) {
    console.log("Add Person", formName, level);
    // does the person cache contain any one?
    if (this.personsCache.length == 0) {
      // open the person modal
      this.launchPersonModal(formName, level);
      return;
    }

    // open the choose modal
    this.dialog.open(KycPersonSelectModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.LARGE),
      disableClose: true,
      data: {
        people: this.personsCache,
        level: level,
      }
    })
    .afterClosed().subscribe({
      next: (data: any) => {
        console.log("Add Person Form Result", data)

        if (!!data) {
          if (data.function == 'ADD') {
            // add person modal
            this.launchPersonModal(formName, level);
          }
          else if (data.function == 'SELECT') {
            // person selected from list
            data.person.percentageOwnership = 0;
            this.getFormArray(formName).push(this.createFormGroupFromObject(data.person));
          }
          else if (data.function == 'EDIT') {
            this.launchPersonModal(formName, level, data.person);
          }
        }
      }
    });
  }

  launchPersonModal(formName: string, level: Level, person?: IKycPerson) {
    console.log("launch person modal", formName, level, person);

    let isNewPerson: boolean = !person;

    if (isNewPerson) {
      person = <IKycPerson> { 
        id: this.uuidService.generateFormattedUUID(),
        businessUnitId: this.dataService.getBuId(),
        businessUnitEntityKycId: this.selectedEntityKycId,
      }
    }

    this.dialog.open(KycPersonModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.LARGE),
      data: {
        person: person,
        level: level,
        disabled: this.isFormDisabled(),
        isNewPerson: isNewPerson
      }
    })
    .afterClosed().subscribe({
      next: (kycPerson: IKycPerson) => {

        console.log("KYC Person results", kycPerson, isNewPerson);
        // person selected from list
        if (!!kycPerson) {
          if (this.isFormDisabled()) {
            this.toastr.error("Cannot save, form disabled!");
            return;
          }


          if (isNewPerson) {
            this.entityKycPersonService.addKycPerson(kycPerson).subscribe({
              next: (newKycPerson: IKycPerson) => {
                console.log("Add New Person Result", newKycPerson);
                newKycPerson.percentageOwnership = 0;
                this.toastr.success(`Natural Person '${newKycPerson.firstName} ${newKycPerson.lastName}' added`);
  
                newKycPerson.errors = [];
                newKycPerson.commonErrors = [];
  
                this.getFormArray(formName).push(this.createFormGroupFromObject(newKycPerson));
                // add the user to the cache
                this.personsCache.push(newKycPerson);
              },
              error: (err: HttpErrorResponse) => {
                console.error(err);
                this.toastr.error("Could not save new Person!");
              }
            })
          }
          else {
            this.entityKycPersonService.updateKycPerson(kycPerson).subscribe({
              next: () => {
                console.log("Update Person Result", kycPerson);
                // person.percentageOwnership = 0;
                this.toastr.success(`Natural Person '${kycPerson.firstName} ${kycPerson.lastName}' updated`);

                this.getFormArray(formName).push(this.createFormGroupFromObject(kycPerson));

                // this.personsCache.push(person);
                this.personsCache.forEach(x => {
                  if (x.id == kycPerson.id) {
                    person = x;
                  }
                })
              },
              error: (err: HttpErrorResponse) => {
                console.error(err);
                this.toastr.error("Could not update Person!");
              }
            })
          }
          
        }
      }
    })
  }

  addLegalEntityToForm(formName: string, level: Level) {
    console.log("Add Legal Entity", formName, level);

    // add legal entity - there is none in the cache
    if (this.legalEntitiesCache.length == 0) {
      this.launchNewLegalEntityModal(formName, level);
      return;
    }

    // add new 
    this.dialog.open(KycBusinessSelectModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.LARGE),
      // maxWidth: '700px',
      disableClose: true,
      data: {
        businesses: this.legalEntitiesCache,
        level: level
      }
    })
    .afterClosed().subscribe({
      next: (data: any) => {
        console.log("Add LE Form Result", data)

        if (!!data) {
          if (data.function == 'ADD') {
            this.launchNewLegalEntityModal(formName, level);
          }
          else if (data.function == 'SELECT') {
            data.business.natureoftheBusiness = '';
            data.business.businessSourceofFund = '';
            data.business.percentageOwnership = 0;
            this.getFormArray(formName).push(this.createFormGroupFromObject(data.business));
          }
          else if (data.function == 'EDIT') {
            this.launchNewLegalEntityModal(formName, level, data.business);
          }
        }
      }
    })
  }

  launchNewLegalEntityModal(formName: string, level: Level, legalEntity?: IKycLegalEntity) {

    let isNewLegalEntity: boolean = !legalEntity;
    console.log("legal entity", legalEntity, isNewLegalEntity);
    
    if (isNewLegalEntity) {
      legalEntity = <IKycLegalEntity> { 
        id: this.uuidService.generateFormattedUUID(),
        businessUnitId: this.dataService.getBuId(),
        businessUnitEntityKycId: this.selectedEntityKycId,
      }
    }

    this.dialog.open(KycBusinessModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.LARGE),
      data: {
        business: legalEntity,
        level: level,
        disabled: this.isFormDisabled(),
        isNewLegalEntity: isNewLegalEntity
      }
    })
    .afterClosed().subscribe({
      next: (legalEntityFromForm: IKycLegalEntity) => {
        console.log("ADD legal entity", legalEntityFromForm as IKycLegalEntity, isNewLegalEntity)
        if (!!legalEntityFromForm) {
          if (this.isFormDisabled()) {
            this.toastr.error("Cannot save, form disabled!");
            return;
          }

          if (isNewLegalEntity) {
            this.entityKycBusinessService.addKycLegalEntity(legalEntityFromForm).subscribe({
              next: (newLegalEntity : IKycLegalEntity) => {
  
                this.toastr.success(`Legal Entity '${newLegalEntity.legalName}' added`);
                
                newLegalEntity.errors = [];
                newLegalEntity.commonErrors = [];
                newLegalEntity.natureoftheBusiness = '';
                newLegalEntity.businessSourceofFund = '';
                newLegalEntity.percentageOwnership = 0;

                // add the LE to the list
                this.getFormArray(formName).push(this.createFormGroupFromObject(newLegalEntity));

                // add the legal entity to the cache
                this.legalEntitiesCache.push(newLegalEntity);
              },
              error: (err: HttpErrorResponse) => {
                console.error(err);
                this.toastr.error("Could not save new Legal Entity!");
              }
            });
          }
          else {
            this.entityKycBusinessService.updateKycLegalEntity(legalEntity).subscribe({
              next: () => {
  
                this.toastr.success(`Legal Entity '${legalEntityFromForm.legalName}' updated`);
                // add the LE to the list
                this.getFormArray(formName).push(this.createFormGroupFromObject(legalEntity));
                // add the legal entity to the cache
                // this.legalEntitiesCache.push(legalEntity);
                this.legalEntitiesCache.forEach(x => {
                  if (x.id == legalEntityFromForm.id) {
                    legalEntity = x;
                  }
                })

              },
              error: (err: HttpErrorResponse) => {
                console.error(err);
                this.toastr.error("Could not update Legal Entity!");
              }
            });
          }

        }
      }
    })
  }

  /**
   * Prompts the user for delete confirmation if the natural person is not used in the form
   * @param person the natural person to remove
   */
  deletePerson(person: IKycPerson) {
    if (this.isPersonUsedOnForm(person)) {
      this.toastr.warning("Person is used in the KYC, please delete them from the KYC form first!", $localize`:@@companyName:Rondeivu`);
      return;
    }

    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      maxWidth: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true,
      data: {
        person: person
      }
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        // delete the peron
        this.entityKycPersonService.deleteKycPerson(this.selectedEntityKycId, person.id).subscribe({
          next: () => {
            this.toastr.success("Person Deleted!");
            this.personsCache = this.personsCache.filter(x => x.id != person.id);
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error("Could not perform operation")
          }
        })
      }
    });
  }

  /**
   * Prompts the user for delete confirmation if the legal entity is not being used in the form
   * @param business the legal entity to remove
   */
  deleteBusiness(business: IKycLegalEntity) {
    if (this.isBusinessUsedOnForm(business)) {
      this.toastr.warning("Legal Entity is used in the KYC, please delete them from the KYC form first!", $localize`:@@companyName:Rondeivu`);
      return;
    }

    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true,
      data: {
        business: business
      }
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        this.entityKycBusinessService.deleteKycLegalEntity(this.selectedEntityKycId, business.id).subscribe({
          next: () => {
            this.toastr.success("Legal Entity Deleted!");
            this.legalEntitiesCache = this.legalEntitiesCache.filter(x => x.id != business.id);
          },
          error: (err: HttpErrorResponse) => {
            this.toastr.error("Could not perform operation")
          }
        })
      }
    });
  }

 
  /**
   * KYC PEOPLE
   */
  private fetchPersons() {
    console.log("Fetching Entity KYC People...");
    this.entityKycPersonService.getKycPeopleByKycId(this.selectedEntityKycId).subscribe({
      next: (persons: IKycPerson[]) => {
        console.log("Fetch Persons", persons);
        this.personsCache = persons.map(x => {
          if (Array.isArray(x.errors)) {
            var errors = x.errors.map(x => x.errorMessage);
            x.commonErrors = errors.filter((item, index) => errors.indexOf(item) === index);
          }
          else {
            x.commonErrors = [];
          }
          return x;
        });
        // .sort((a, b) => {
        //   const dateA = new Date(a.created); // Convert the Created field to Date
        //   const dateB = new Date(b.created); // Convert the Created field to Date
          
        //   return dateA.getTime() - dateB.getTime(); // Compare the dates
        // });
      }, error: (error: any) => {
        this.toastr.error("Unable to get kyc people!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }


  isPersonUsedOnForm(person: IKycPerson): boolean {
    return this.idUsedInFormPropData(person.id, this.FORM_ONBOARDING_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_CONTROL_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_DBO_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_IDBO_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_TRUST_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_TRUST_SET_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_TRUST_BEN_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_GB_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_AUTH_PEOPLE) ||
      this.idUsedInFormPropData(person.id, this.FORM_DIRECTORS);

  }

  isBusinessUsedOnForm(business: IKycLegalEntity): boolean {
    return this.idUsedInFormPropData(business.id, this.FORM_CLIENT_ENTITY) ||
      this.idUsedInFormPropData(business.id, this.FORM_REG_ENT) ||
      this.idUsedInFormPropData(business.id, this.FORM_DBO_ENTITIES) ||
      this.idUsedInFormPropData(business.id, this.FORM_IDBO_ENTITIES) ||
      this.idUsedInFormPropData(business.id, this.FORM_TRUST_ENTITIES) ||
      this.idUsedInFormPropData(business.id, this.FORM_TRUST_SET_ENTITIES) ||
      this.idUsedInFormPropData(business.id, this.FORM_TRUST_BEN_ENTITIES) ||
      this.idUsedInFormPropData(business.id, this.FORM_GB_ENTITIES);
  }

  private idUsedInFormPropData(id: string, prop: string): boolean {
    let data = this.form.get(prop)?.value;
    if (!!data) {
      for (let i = 0; i <= data.length - 1; i++) {
        if (data[i].id == id) {
          return true;
        }
      }
    }

    return false;
  }

  /**
   * KYC LEGAL ENTITIES
   */
  private fetchLegalEntities() {
    // console.log("Fetching Entity KYC Legal Entiies...");
    this.entityKycBusinessService.getKycLegalEntityByKycId(this.selectedEntityKycId).subscribe({
      next: (legalEntities: IKycLegalEntity[]) => {
        console.log("Fetch Legal Entities", legalEntities);
        this.legalEntitiesCache = legalEntities.map(x => {
          if (Array.isArray(x.errors)) {
            var errors = x.errors.map(x => x.errorMessage);
            x.commonErrors = errors.filter((item, index) => errors.indexOf(item) === index);
          }
          else {
            x.commonErrors = [];
          }
          return x;
        })


        
        // .sort((a, b) => {
        //   const dateA = new Date(a.created); // Convert the Created field to Date
        //   const dateB = new Date(b.created); // Convert the Created field to Date
          
        //   return dateA.getTime() - dateB.getTime(); // Compare the dates
        // });;;
      }, error: (error: any) => {
        this.toastr.error("Unable to get kyc legal entities!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  prevSection(index: number) {
    var mainExpansionPanels = this.expansionPanels.toArray();
    if (index > 0) {
      mainExpansionPanels[index]?.close();
      mainExpansionPanels[index - 1]?.open();
    }
  }

  nextSection(index: number, save: boolean) {
    var mainExpansionPanels = this.expansionPanels.toArray();
    if (save == false) {
      mainExpansionPanels[index]?.close();
      mainExpansionPanels[index + 1]?.open();
      return;
    }
    else {
      this.saveTheKyc().then(() => {
        mainExpansionPanels[index]?.close();
        mainExpansionPanels[index + 1]?.open();
      })
      .catch((err) => {
        console.error(err);
        this.toastr.error("Error occured");
      });
    }
  }

  panelOpened(e: string) {
    console.log("Panel opened", e, e as KycSectionType);
    this.openedKycSection = e as KycSectionType;
  }

}


@Component({
  selector: 'kyc-person',
  template: `<div *ngIf="!!person" style="display: flex; gap: 8px; align-items: center">
              <mat-icon [matBadge]="errors.length > 0 ? errors.length : null" [title]="errorMsg" matBadgeColor="warn">person</mat-icon>
              <span>{{person.firstName}} {{person.lastName}}</span>
            </div>`,
  styles: []
})
export class KycPersonDisplay implements OnChanges {
  @Input() person!: IKycPerson;
  @Input() section!: KycSectionType | string;
  errors: string[] = [];
  errorMsg: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (this.person != null && this.person.errors != null && Array.isArray(this.person.errors)) {
      this.errors = this.person.errors.filter(x => x.kycSectionType == this.section).map(x => x.errorMessage);
      this.errorMsg = this.errors.join("\n\r");
    }
  }
}


@Component({
  selector: 'kyc-entity',
  template: `<div *ngIf="!!legalEntity" style="display: flex; gap: 8px; align-items: center">
              <mat-icon [matBadge]="errors.length > 0 ? errors.length : null" [title]="errorMsg" matBadgeColor="warn">business</mat-icon>
              <span>{{legalEntity.legalName}}</span>
            </div>`,
  styles: []
})
export class KycLegalEntityDisplay implements OnChanges {
  @Input() legalEntity!: IKycLegalEntity;
  @Input() section!: KycSectionType | string;
  errors: string[] = [];
  errorMsg: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (this.legalEntity != null && this.legalEntity.errors != null && Array.isArray(this.legalEntity.errors)) {
      this.errors = this.legalEntity.errors.filter(x => x.kycSectionType == this.section).map(x => x.errorMessage);
      this.errorMsg = this.errors.join("\n\r");
    }
  }
}